import { render, staticRenderFns } from "./PageSizeChanger.vue?vue&type=template&id=21b3aa87&scoped=true&"
import script from "./PageSizeChanger.vue?vue&type=script&lang=js&"
export * from "./PageSizeChanger.vue?vue&type=script&lang=js&"
import style0 from "./PageSizeChanger.vue?vue&type=style&index=0&id=21b3aa87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3aa87",
  null
  
)

export default component.exports